import { Flex, Text, useTheme } from '@chakra-ui/react'

import type { FlexProps } from '@chakra-ui/react'

const componentSizes = ['sm', 'md', 'lg'] as const
type NotificationBadgeSize = (typeof componentSizes)[number]
export type NotificationBadgeStyleProps<TComponentParts extends FlexProps> = {
  [key in NotificationBadgeSize]: TComponentParts
}

type Props = {
  value?: number
  size?: NotificationBadgeSize
  hideShadow?: boolean
}

const notificationBadgeStyleProps: NotificationBadgeStyleProps<{
  height: string
  width: string
  borderRadius: string
  fontSize?: string
}> = {
  sm: {
    height: '8px',
    width: '8px',
    borderRadius: '4px',
  },
  md: {
    height: '14px',
    width: '14px',
    borderRadius: '7px',
    fontSize: '8px',
  },
  lg: {
    height: '16px',
    width: '16px',
    borderRadius: '8px',
    fontSize: '10px',
  },
}

const NotificationBadge = ({ value = 1, size = 'lg', hideShadow = false }: Props) => {
  const theme = useTheme()

  return (
    <Flex
      align="center"
      justify="center"
      background={theme.baseColors.danger.main}
      color={theme.colors.white}
      {...notificationBadgeStyleProps[size]}
      {...(!hideShadow && { boxShadow: theme.shadows.base })}
    >
      {size !== 'sm' && (
        <Text textStyle="captionBold2" textAlign="center" noOfLines={1}>
          {value}
        </Text>
      )}
    </Flex>
  )
}

export default NotificationBadge
